import "./lib.mcss";
import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://763f3a1998d9bc072c64337accde176d@o975316.ingest.us.sentry.io/4509459917897728",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
});
